import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { setLanguage } from 'actions'

interface UrlLanguageProps {
  dispatch: any
  params: { language: string }
  languages: object
  children?: any // todo figure out what type this should be?
}

export function UrlLanguage({
  dispatch,
  params,
  languages,
  children,
}: UrlLanguageProps) {
  const [currentLanguage, setCurrentLanguage] = useState<string>(
    params.language
  )
  const changeLanguage = (language: string) => {
    if (language in languages) {
      setCurrentLanguage(language)
      dispatch(setLanguage(language))
    } else {
      // Fallback to english
      setCurrentLanguage('en')
      dispatch(setLanguage('en'))
    }
  }

  useEffect(() => {
    changeLanguage(params.language)
  }, [])

  useEffect(() => {
    if (params.language !== currentLanguage) {
      changeLanguage(params.language)
    }
  }, [params.language])

  return children || null
}

export default connect()(UrlLanguage)
